import styled from 'styled-components';
import { Button, Space } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

export const ContentWrapper = styled.div<IToken & { scheme?: string }>`
  padding: 24px;
  background: ${(props) => {
    const { themesList } = require('constants/themesList');
    const currentTheme = themesList[props.scheme || 'deepBlueTheme'];
    return (
      currentTheme?.colorBgLayout || themesList.deepBlueTheme.colorBgLayout
    );
  }};
  min-height: calc(100vh - 200px);
`;

export const Title = styled.h1<IToken & { scheme?: string }>`
  color: ${(props) => {
    const darkThemes = ['darkUITheme', 'deepBlueTheme', 'deepNavyTheme'];
    return darkThemes.includes(props.scheme || '') ? '#fff' : '#000';
  }};
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 600;
`;

export const EditButton = styled(Button)<{ scheme?: string }>`
  color: ${(props) => {
    const darkThemes = ['darkUITheme', 'deepBlueTheme', 'deepNavyTheme'];
    return darkThemes.includes(props.scheme || '')
      ? '#000 !important'
      : 'inherit';
  }};
`;

export const ButtonSpace = styled(Space)`
  margin-bottom: 16px;
`;
